import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App'; // Adjust the path based on your project structure

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
